<template>
  <div class="">
    <div>
      <a-table :columns="columns" :data-source="displayDistroCenters" :loading="tableLoading" :pagination="pagination"
        class="tableStyle">
        <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          style="padding: 8px">
          <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
            Search
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
            Reset
          </a-button>
        </div>

        <div slot="filterCategoryDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          style="padding: 8px">
          <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
            Search
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
            Reset
          </a-button>
        </div>

        <div slot="filterSupplierDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          style="padding: 8px">
          <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
            Search
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
            Reset
          </a-button>
        </div>
      </a-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "AllDistroCenterTable",
  props: {
    inventories: {
      type: Object,
      default: function () {
        return { data: [] };
      },
    },
  },
  data: () => ({
    tableLoading: false,
    selectedCentre: {},
    pagination: {
      pageSize: 20,
    },
    searchText: "",
    searchInput: null,
    searchedColumn: '',
    columns: [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "Product Name",
        dataIndex: "brandName",
        key: "brandName",
        scopedSlots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
          record.brandName
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      },
      {
        title: "Product Category",
        dataIndex: "categoryName",
        key: "categoryName",
        scopedSlots: {
          filterDropdown: 'filterCategoryDropdown',
          filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
          record.categoryName
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      },
      {
        title: "Product Supplier",
        dataIndex: "supplierName",
        key: "supplierName",
        scopedSlots: {
          filterDropdown: 'filterSupplierDropdown',
          filterIcon: 'filterIcon',
        },
        onFilter: (value, record) =>
          record.supplierName
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
      },
      {
        title: "Product SKU",
        dataIndex: "sku",
        key: "sku",
      },
      {
        title: "Purchase Price",
        dataIndex: "purchasePrice",
        key: "purchasePrice",
      },
      {
        title: "Selling Price",
        dataIndex: "sellingPrice",
        key: "sellingPrice",
      },
      {
        title: "Product Quantity",
        dataIndex: "balance",
        key: "balance",
      },
      {
        title: "Inventory Value",
        dataIndex: "inventoryValue",
        key: "inventoryValue",
      },
    ],
    displayDistroCenters: [],
  }),
  watch: {
    inventories: function (newInventories) {
      this.setTableData(newInventories);
    },
  },
  methods: {
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = '';
    },
    setTableData(inventories) {
      // console.log('new distros', newDistros);
      this.displayDistroCenters = [...inventories.data];
      this.displayDistroCenters.forEach((inventory) => {
        let invenTotal = 0;
        invenTotal = inventory.sellingPrice * inventory.balance
        inventory.createdAt = moment(inventory.createdAt).format("DD-MMM-YYYY");
        inventory.key = inventory.id + inventory.brandName;
        inventory.purchasePrice = inventory.purchasePrice
          ? `Ksh ${inventory.purchasePrice.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}`
          : "N/A";
        inventory.sellingPrice = inventory.sellingPrice
          ? `Ksh ${inventory.sellingPrice.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}`
          : "N/A";
        inventory.inventoryValue = invenTotal
          ? `Ksh ${invenTotal.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}`
          : "N/A";
      });
    },
  },
  mounted() {
    this.setTableData(this.inventories);
  },
};
</script>

<style lang="scss" scoped>
.requestActions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}

.card-container>.ant-tabs-card>.ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  height: 40px;
  color: #98c14b;
  background: #e5efe7;
  border-color: #e5efe7;
  border-bottom: 1px solid #98c14b;
}

.card-container>>>.ant-tabs-tab {
  height: 40px;
  margin: 0;
  width: 217px;
  margin-right: 2px;
  padding: 0 16px;
  line-height: 38px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
}

.card-container>>>.ant-tabs-tab:hover {
  color: #98c14b;
  /* background: #e5efe7; */
}

.modalStyle>>>.ant-modal-header {
  border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
  border-top: none;
}

.modalStyle {
  display: flex;
  justify-content: center;
}

.card-container>>>.ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #98c14b;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}

.spinner>>>.ant-spin-dot-item {
  background-color: #418a49;
}

.card-container>.ant-tabs-card>.ant-tabs-bar {
  border-color: #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}

.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}

button:hover {
  color: #418a49;
  outline-color: #418a49;
  border-color: #418a49;
}



.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #26A246;
  color: #fff;

}

.tableStyle>>>.ant-table-thead th {
  background: #fff;
  height: 63px;
}

.tableStyle>>>.ant-table-header {
  background: #fff !important;
}
</style>